import { DependencyList, useEffect } from 'react';

const useElementsHeight = ({
  selectors,
  isScrollStyle,
  dependency,
  cssVariable,
}: {
  selectors: string[];
  isScrollStyle: boolean;
  dependency?: DependencyList;
  cssVariable: string;
}) => {
  useEffect(() => {
    if (isScrollStyle) {
      // Calculate the total height of all elements matching the selectors
      const totalHeight = selectors.reduce((acc, selector) => {
        const elements = document.querySelectorAll(selector);
        return (
          acc +
          Array.from(elements).reduce((sum, element) => {
            return sum + (element as HTMLElement).offsetHeight;
          }, 0)
        );
      }, 0);

      // Set the total height of all elements as a CSS variable
      document.documentElement.style.setProperty(`--${cssVariable}`, `${totalHeight}px`);
    }
  }, [cssVariable, selectors, isScrollStyle, dependency]);
};

export default useElementsHeight;
